import React from 'react';
import {
  Box, Button, Divider, Typography,
} from '@mui/material';
import { dividerClasses } from '@mui/material/Divider';
import { observer } from 'mobx-react';
import { Trans } from '@gamiphy/react-i18n';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { DiscountDto, DiscountDtoTypeEnum } from '@coretava/api/ecommerce-service';
import { Product } from '@gamiphy/bl/product';
import { ProductApi } from '@gamiphy/gamix-modules/product';

const CongratsActions: React.FC<{
  discount: DiscountDto,
}> = ({
  discount,
}) => {
  const [product, setProduct] = React.useState<Product>();

  React.useEffect(() => {
    if (discount.skuDetails?.productId) {
      void ProductApi.getExternalProduct(discount.skuDetails.productId)
        .then((p) => setProduct(p));
    }
  }, [discount]);

  const action = React.useMemo(() => {
    switch (discount.type) {
      case DiscountDtoTypeEnum.FreeSku:
        return (
          <Button
            variant="contained"
            sx={{ fontSize: 14 }}
            fullWidth
            onClick={() => window.open(product?.url, '_blank')}
          >
            <Trans
              i18nKey="shared.claimNow"
              defaults="Claim Now"
            />
          </Button>
        );
      default:
        return (
          <Button variant="contained" sx={{ fontSize: 14 }} fullWidth onClick={() => UiStore.close()}>
            <Trans
              i18nKey="campaigns.boosters.survey.shopNow"
              defaults="Shop now!"
            />
          </Button>
        );
    }
  }, [discount, product]);

  return React.useMemo(() => {
    if (AppStore.isOmniApp) {
      return (
        <Box display="flex" flexDirection="column" gap={1} mt={1} alignItems="center">
          <Typography fontSize={14} fontWeight={600}>
            <Trans
              i18nKey="campaigns.boosters.survey.store.visitToday"
              defaults="Visit our store today!"
            />
          </Typography>
          <Divider sx={{
            width: '100%',
            fontSize: 14,
            fontWeight: 600,
            [`& .${dividerClasses.wrapper}`]: {
              px: 4,
            },
            '&::before':
              {
                borderTopWidth: '1px',
                borderColor: '#000',
              },
            '&::after': {
              borderTopWidth: '1px',
              borderColor: '#000',
            },
          }}
          >
            <Trans
              i18nKey="or"
              defaults="Or"
            />
          </Divider>
          {action}
        </Box>
      );
    }

    return action;
  }, [action, AppStore.isOmniApp]);
};

export default observer(CongratsActions);
